import React from "react"
import cx from "classnames"

type Props = {
  className?: string
  children: string
}

H2.defaultProps = {
  className: "",
}

function H2({ children, className }: Props) {
  return (
    <h2 className={cx("font-base", "text-black", "leading-7", className)}>
      {children}
    </h2>
  )
}

export default H2
